import { render, staticRenderFns } from "./ImportHistory.vue?vue&type=template&id=5a5b9f3c"
import script from "./ImportHistory.vue?vue&type=script&lang=js"
export * from "./ImportHistory.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/flexben.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports